import { keyframes } from '@emotion/react';
import { Flex, Text, theme } from '../2022-component-library';
import { useMediaQuery } from '../helpers/useMediaQuery';

const CameraCalibrationStatusIndicator = ({ currentStatus }) => {
  const smallScreen = useMediaQuery('(max-width: 800px)');
  const statusMap = { 0: 'Not Calibrated', 1: 'Calibrating...', 2: 'Calibration Complete' };
  return (
    <Flex
      column
      centered
      width='50%'
      maxWidth='350px'
      padding={smallScreen ? '0.75rem' : '1rem'}
      boxShadow='0px 0px 6px rgba(0, 0, 0, 0.26)'
      borderRadius='12px'
      gap={smallScreen ? '1rem' : '2rem'}
    >
      <Flex width='100%' justifyContent='space-evenly'>
        <TrafficLight color='red' active={currentStatus === 0} />
        <TrafficLight color='amber' active={currentStatus === 1} />
        <TrafficLight color='green' active={currentStatus === 2} />
      </Flex>
      <Flex centered width='100%' fontSize={smallScreen ? '0.825rem' : '1rem'}>
        <Text fontWeight='bold' width='55%' textAlign='right'>{`Calibration Status:\u00a0`}</Text>
        <Text width='45%'>{statusMap[currentStatus]}</Text>
      </Flex>
    </Flex>
  );
};

const TrafficLight = ({ color, active }) => {
  const smallScreen = useMediaQuery('(max-width: 800px)');
  const bgColors = { red: theme.colors.error, amber: theme.colors.warning, green: theme.colors.success };
  return (
    <Flex
      borderRadius='50%'
      height={smallScreen ? '30px' : '40px'}
      width={smallScreen ? '30px' : '40px'}
      backgroundColor={bgColors[color]}
      style={{ opacity: active ? 1 : 0.3 }}
      animation={color === 'amber' && active ? `${growFade} 1200ms infinite` : null}
    ></Flex>
  );
};

const growFade = keyframes`
0% {
  opacity: 1;
  transform: scale(0);
}

100% {
  opacity: 0;
  transform: scale(1.2);
}
`;

export default CameraCalibrationStatusIndicator;
